import {
  Box,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Alert,
} from "@mui/material";
import { IDeliveryMethod, IAddress } from "../../types/seed";
import { getBestAddress } from "../../utils/addressUtils";

interface DeliveryStepProps {
  isFormValid: boolean;
  deliveryMethods: IDeliveryMethod[];
  deliveryMethodId: number | null;
  setDeliveryMethodId: (method: number) => void;
  address: string | null;
  seedAddress: string;
  seedAddressObj?: IAddress | null;
  deliveryWeekday: string;
  onChangeAddress: () => void;
  addressError?: string | null;
}

const DeliveryStep: React.FC<DeliveryStepProps> = ({
  isFormValid,
  deliveryMethods,
  deliveryMethodId,
  setDeliveryMethodId,
  address,
  seedAddress,
  seedAddressObj,
  deliveryWeekday,
  onChangeAddress,
  addressError,
}) => {
  const hasHomeDelivery = deliveryMethods.some(
    (deliveryMethod: IDeliveryMethod) => deliveryMethod.is_home_delivery,
  );
  return (
    <Box>
      <Typography variant="h4" component="h2" gutterBottom>
        Entrega
      </Typography>
      {isFormValid ? (
        <Typography color="primary.main">
          Selecione uma opção de entrega
        </Typography>
      ) : null}
      <FormControl>
        <RadioGroup
          onChange={(e) => {
            setDeliveryMethodId(parseInt(e.target.value));
          }}
          sx={{ marginBottom: "1rem" }}
          value={deliveryMethodId}
        >
          {deliveryMethods.map((deliveryMethod: IDeliveryMethod) => (
            <FormControlLabel
              key={deliveryMethod.id}
              value={deliveryMethod.id}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: "2rem",
                    },
                  }}
                />
              }
              label={
                <div>
                  <Typography variant="h6" component="div">
                    {deliveryMethod.title}{" "}
                    {parseFloat(deliveryMethod.fee) > 0
                      ? `(+ R$ ${deliveryMethod.fee})`
                      : ""}
                  </Typography>
                  <Typography variant="body1" component="div">
                    {deliveryMethod.is_home_delivery
                      ? address
                      : getBestAddress(seedAddressObj, seedAddress)}
                  </Typography>
                  <Typography
                    variant="body1"
                    component="div"
                    color="text.secondary"
                  >
                    {deliveryMethod.is_home_delivery
                      ? `Sua entrega está programada para: ${deliveryWeekday}.`
                      : `O dia para retirada da sua feira é: ${deliveryWeekday}.`}
                  </Typography>
                </div>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
      {hasHomeDelivery && (
        <Button onClick={onChangeAddress} sx={{ display: "block", mb: 2 }}>
          Trocar endereço
        </Button>
      )}
      {addressError && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {addressError}
        </Alert>
      )}
    </Box>
  );
};

export default DeliveryStep;
